module.exports = __webpack_public_path__ + "resource/static/img/icon13@1.5x.b34f6ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon13@1.5x.png
// module id = ChZX
// module chunks = 1